import type { UnidadResumen } from '../../types/consultas';

const ZONA_BOGOTA = 'America/Bogota';

const FECHA_HORA = new Intl.DateTimeFormat('es-CO', {
  timeZone: ZONA_BOGOTA,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const HORA = new Intl.DateTimeFormat('es-CO', {
  timeZone: ZONA_BOGOTA,
  hour: 'numeric',
  minute: '2-digit',
});

/** Instante ISO (emisión, envío) → «21/09/2026, 10:00 a. m.» en hora de Bogotá. */
export function formatInstante(iso: string): string {
  const fecha = new Date(iso);
  return Number.isNaN(fecha.getTime()) ? iso : FECHA_HORA.format(fecha);
}

/** Hora de Bogotá de un instante ISO («3:45 p. m.»). */
export function formatHora(iso: string): string {
  const fecha = new Date(iso);
  return Number.isNaN(fecha.getTime()) ? iso : HORA.format(fecha);
}

export function etiquetaUnidad(unidad: Pick<UnidadResumen, 'torre' | 'numero'>): string {
  return `${unidad.torre} · ${unidad.numero}`;
}

/** Huella SHA-256 abreviada para lectura («9f86d0…a08f»); la completa va en `title`. */
export function huellaCorta(huella: string | null | undefined): string {
  if (!huella) return '—';
  return huella.length > 16 ? `${huella.slice(0, 8)}…${huella.slice(-4)}` : huella;
}
